export const EXTERNAL_PAYPAL_METHOD_TYPE = 'external_paypal';
export const STRIPE_VERIFY_INTENT_PUBLIC_PATH =
  '/stripe/payment_intents_verify/verify';
